import { useState } from 'react';

function NavigateStockMarketModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Navigating the Stock Market",
      content: [
        "What is Navigating the Stock Market?",
        "Overview of the stock market's role in the economy.",
        "The essentials of understanding how the market operates and why it is important for investors.",
        "Introduction to key concepts like market trends, volatility, and liquidity."
      ]
    },
    {
      title: "Module 2: Stock Market Participants",
      content: [
        "Who Are the Key Players in the Stock Market?",
        "Retail Investors: Individual investors participating in the market.",
        "Institutional Investors: Large entities like mutual funds, pension funds, and hedge funds.",
        "Market Makers and Brokers: Facilitating trading and maintaining market liquidity.",
        "Regulators: Entities like SEBI ensuring fair market practices."
      ]
    },
    {
      title: "Module 3: Types of Stocks and How to Choose",
      content: [
        "Understanding Different Types of Stocks",
        "Common vs. Preferred Stocks: Key differences in terms of rights and dividends.",
        "Growth Stocks: Stocks expected to grow at an above-average rate.",
        "Value Stocks: Stocks undervalued compared to their intrinsic value.",
        "Blue-chip Stocks: Established companies with stable performance.",
        "Dividend Stocks: Stocks that provide regular dividend income."
      ]
    },
    {
      title: "Module 4: The Role of Stock Exchanges",
      content: [
        "How Stock Exchanges Facilitate Trading",
        "Overview of major stock exchanges like NSE, BSE, NYSE, and their role in price discovery and liquidity.",
        "The function of stock exchanges in listing securities and facilitating trading.",
        "How trading works on exchanges and the importance of order matching systems."
      ]
    },
    {
      title: "Module 5: Understanding Market Trends and Sentiment",
      content: [
        "Bull and Bear Markets",
        "Definitions of Bull Market (rising market) and Bear Market (falling market).",
        "How to recognize market trends and invest accordingly.",
        "The psychology of market sentiment and how it impacts stock prices."
      ]
    },
    {
      title: "Module 6: Key Economic Indicators Influencing the Market",
      content: [
        "Understanding Market Influencers",
        "GDP Growth: How economic growth drives market performance.",
        "Inflation and Interest Rates: How these affect stock prices and market behavior.",
        "Corporate Earnings: The role of earnings reports in stock valuation."
      ]
    },
    {
      title: "Module 7: Risk Management in Stock Trading",
      content: [
        "Mitigating Risks While Navigating the Market",
        "Types of investment risks: Market risk, liquidity risk, and interest rate risk.",
        "Tools to manage risk: Stop-loss orders, diversification, and portfolio allocation.",
        "Understanding your risk tolerance and aligning it with your investment strategy."
      ]
    },
    {
      title: "Module 8: Technical Analysis for Navigating the Market",
      content: [
        "Using Charts and Indicators",
        "Introduction to Candlestick Charts, Line Charts, and Bar Charts.",
        "Key technical indicators: Moving Averages, RSI, MACD, Bollinger Bands.",
        "Identifying trends, support/resistance levels, and trading signals."
      ]
    },
    {
      title: "Module 9: Fundamental Analysis for Long-Term Success",
      content: [
        "Analyzing the Financial Health of Stocks",
        "How to read balance sheets, income statements, and cash flow reports.",
        "Key financial ratios: P/E, P/B, Dividend Yield, ROE.",
        "Evaluating the growth potential of a company through fundamentals."
      ]
    },
    {
      title: "Module 10: Developing a Stock Trading Strategy",
      content: [
        "Creating a Plan for Market Navigation",
        "Short-term vs. long-term trading strategies.",
        "Day trading, swing trading, and buy-and-hold strategies.",
        "How to craft a strategy that suits your financial goals and risk tolerance."
      ]
    },
    {
      title: "Module 11: Building and Managing a Stock Portfolio",
      content: [
        "Constructing a Balanced Portfolio",
        "The importance of diversification to reduce risk.",
        "How to allocate assets across sectors and geographies.",
        "Regular portfolio reviews and rebalancing to maintain alignment with financial objectives."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Our Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NavigateStockMarketModule;
